import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Seo } from "@/components/Seo";

import Index from "@/pages/Index";
import Tjenester from "@/pages/Tjenester";
import Innlevering from "@/pages/Innlevering";
import ViktigInfo from "@/pages/ViktigInfo";
import Bedrift from "@/pages/Bedrift";
import ProfesjonelleKaffemaskiner from "@/pages/ProfesjonelleKaffemaskiner";
import Transport from "@/pages/Transport";
import Booking from "@/pages/Booking";
import Sporing from "@/pages/Sporing";
import Verksted from "@/pages/Verksted";
import Kontakt from "@/pages/Kontakt";
import KontaktSkjema from "@/pages/KontaktSkjema";
import Vilkar from "@/pages/Vilkar";
import Faq from "@/pages/Faq";
import Godkjenning from "@/pages/Godkjenning";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminAIRequests from "@/pages/admin/AdminAIRequests";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminSchedule from "@/pages/admin/AdminSchedule";
import AdminPrices from "@/pages/admin/AdminPrices";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminRepairOrders from "@/pages/admin/AdminRepairOrders";
import AdminMachines from "@/pages/admin/AdminMachines";
import AdminScan from "@/pages/admin/AdminScan";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminActivityLog from "@/pages/admin/AdminActivityLog";
import AdminEmailTemplates from "@/pages/admin/AdminEmailTemplates";
import AdminNotificationHistory from "@/pages/admin/AdminNotificationHistory";
import AdminContactRequests from "@/pages/admin/AdminContactRequests";
import AdminKnowledgeBase from "@/pages/admin/AdminKnowledgeBase";
import AdminCommunication from "@/pages/admin/AdminCommunication";
import AdminAgentSettings from "@/pages/admin/AdminAgentSettings";
import AdminAccounting from "@/pages/admin/AdminAccounting";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Seo />
        <Routes>
          {/* Public (Norwegian) */}
          <Route path="/" element={<Index />} />
          <Route path="/tjenester" element={<Tjenester />} />
          <Route path="/innlevering" element={<Innlevering />} />
          <Route path="/viktig-info" element={<ViktigInfo />} />
          <Route path="/bedrift" element={<Bedrift />} />
          <Route path="/profesjonelle-kaffemaskiner" element={<ProfesjonelleKaffemaskiner />} />
          <Route path="/transport" element={<Transport />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/service" element={<Booking />} />
          <Route path="/sporing" element={<Sporing />} />
          <Route path="/portal" element={<Sporing />} />
          <Route path="/verksted" element={<Verksted />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/kontakt-skjema" element={<KontaktSkjema />} />
          <Route path="/vilkar" element={<Vilkar />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/godkjenning/:token" element={<Godkjenning />} />

          {/* Admin (login Norwegian, panel Russian) */}
          <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/foresporler" element={<AdminRequests />} />
            <Route path="/admin/innleveringer" element={<AdminSubmissions />} />
            <Route path="/admin/ai-requests" element={<AdminAIRequests />} />
            <Route path="/admin/bestillinger" element={<AdminBookings />} />
            <Route path="/admin/raspisanie" element={<AdminSchedule />} />
            <Route path="/admin/tseny" element={<AdminPrices />} />
            <Route path="/admin/kunder" element={<AdminCustomers />} />
            <Route path="/admin/reparasjoner" element={<AdminRepairOrders />} />
            <Route path="/admin/mashiny" element={<AdminMachines />} />
            <Route path="/admin/skann" element={<AdminScan />} />
            <Route path="/admin/skann/:code" element={<AdminScan />} />
            <Route path="/admin/polzovateli" element={<AdminUsers />} />
            <Route path="/admin/aktivitetslogg" element={<AdminActivityLog />} />
            <Route path="/admin/shablony-email" element={<AdminEmailTemplates />} />
            <Route path="/admin/istoriya-uvedomleniy" element={<AdminNotificationHistory />} />
            <Route path="/admin/svyazatsya" element={<AdminContactRequests />} />
            <Route path="/admin/baza-znaniy" element={<AdminKnowledgeBase />} />
            <Route path="/admin/kommunikasjon" element={<AdminCommunication />} />
            <Route path="/admin/agent-vadim" element={<AdminAgentSettings />} />
            <Route path="/admin/regnskap" element={<AdminAccounting />} />
            <Route path="/admin/innstillinger" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
